import { render, staticRenderFns } from "./activityDataExport.vue?vue&type=template&id=03988984&scoped=true"
import script from "./activityDataExport.vue?vue&type=script&lang=js"
export * from "./activityDataExport.vue?vue&type=script&lang=js"
import style0 from "./activityDataExport.vue?vue&type=style&index=0&id=03988984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03988984",
  null
  
)

export default component.exports